import { sendRequest, HttpMethods } from "../util/ApiHelper";

const CONTROLLER_NAME = "Validations";

export const getCascadeValues = async () => {
    return await sendRequest(
        HttpMethods.GET,
        `${CONTROLLER_NAME}/GetCascadeValues`
    );
};

/**
 * US 906024 (mobile side of US 873279) - the cascade "required" flags for the plant.
 *
 * A sibling endpoint of GetCascadeValues rather than an extension of it: GetCascadeValues
 * returns a bare array that is assigned straight into the store, so its shape must not change.
 */
export const getCascadeRequiredValues = async () => {
    return await sendRequest(
        HttpMethods.GET,
        `${CONTROLLER_NAME}/GetCascadeRequiredValues`
    );
};
